import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Minute } from './util/Time';
import { persistQueryClient } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { PublicClientApplication } from '@azure/msal-browser';
import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from '@azure/msal-react';
import LoginForm from './components/login-form';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10 * Minute,
      retry: 2,
      retryDelay: attempt => Math.min(200 * 2 ** attempt, 5000)
    }
  }
})

const sessionStoragePersister = createSyncStoragePersister({ storage: window.localStorage })

persistQueryClient({
  queryClient: queryClient,
  persister: sessionStoragePersister,
  maxAge: Infinity
})

const msalConfig = {
  clientId: 'f3399023-2975-4ab4-8221-2f910b898c3a',
  authority: 'https://login.microsoftonline.com/bfa98759-cf17-4f76-a45b-7f0474af636f',
  redirectUri: '/'
}
const msalInstance = new PublicClientApplication({ auth: msalConfig, cache: { cacheLocation: 'localStorage' } })

msalInstance.initialize().then(() => {
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <MsalProvider instance={msalInstance}>
          <AuthenticatedTemplate>
            <App />
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <LoginForm />
          </UnauthenticatedTemplate>
        </MsalProvider>
      </QueryClientProvider>
    </React.StrictMode>
  );
})